import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=0e58f3a2&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=0e58f3a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Menu: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Menu.vue').default,Dropdown: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Dropdown.vue').default,Well: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Well.vue').default})
